import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useFormik } from "formik";
import { useSnackbar } from "notistack";
import * as React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import * as yup from "yup";
import Button from "@/components/Button";
import { login } from "@/redux/slices/auth";
import { useTranslation } from "react-i18next";

const validationSchema = yup.object({
	Eamil: yup
		.string()
		.email("이메일 형식으로 입력해주세요")
		.required("이메일을 입력해주세요"),
	PassWord: yup
		.string()
		.required("비밀번호를 입력해주세요")
		.matches(
			/^(?=.*[a-zA-Z])(?=.*[0-9]).{8,20}$|^(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}$|^(?=.*[^a-zA-Z0-9])(?=.*[0-9]).{8,20}$/,
			"8~20자 사이, 영문(대소문자)+숫자+특수문자 중 2종류 이상을 조합하여 사용할 수 있습니다",
		),
});

export default function SignInInputBox() {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const dispatch = useDispatch();
	const history = useHistory();

	const formik = useFormik({
		initialValues: {
			Eamil: "",
			PassWord: "",
		},
		validationSchema,
		onSubmit: (values) => {
			const requestData = {
				email: values.Eamil,
				password: values.PassWord,
				snsId: "",
				loginType: "email",
			};
			dispatch(
				login({
					requestData,
					callback: () => history.push("/"),
					enqueueSnackbar,
				}),
			);
		},
	});
	return (
		<div>
			<form onSubmit={formik.handleSubmit}>
				<Box
					sx={{
						maxWidth: "100%",
						marginBottom: "1rem",
					}}
				>
					<Typography sx={{ color: "#0d0d0d94", textAlign: "left" }}>
						{t("email")}
					</Typography>
					<TextField
						fullWidth
						id="Eamil"
						value={formik.values.Eamil}
						onChange={formik.handleChange}
						error={formik.touched.Eamil && Boolean(formik.errors.Eamil)}
						helperText={formik.touched.Eamil && formik.errors.Eamil}
					/>
				</Box>
				<Box
					sx={{
						maxWidth: "100%",
						marginBottom: "1rem",
					}}
				>
					<Typography sx={{ color: "#0d0d0d94", textAlign: "left" }}>
						{t("password")}
					</Typography>
					<TextField
						fullWidth
						id="PassWord"
						type="password"
						value={formik.values.PassWord}
						onChange={formik.handleChange}
						error={formik.touched.PassWord && Boolean(formik.errors.PassWord)}
						helperText={formik.touched.PassWord && formik.errors.PassWord}
					/>
				</Box>
				<Button
					variant="contained"
					backgroundColor="#0071E3"
					sx={{
						height: "3.5rem",
						marginBottom: "2rem",
						fontWeight: "bold",
						fontSize: "1.2rem",
					}}
					fullWidth={true}
					type="submit"
				>
					{t("login.sign_in")}
				</Button>
			</form>
		</div>
	);
}
